// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.452.1-TSS-2995-mcastro-IMPROVEMENT-NZ-KeyWord-Panels-Filtering-Tool.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
